import { Component } from "solid-js";

const PrivacyPolicy: Component = () => {
  return (
    <>
      <h1 class="text-xl">Privacy Policy</h1>
      <p>...</p>
    </>
  );
};

export default PrivacyPolicy;
